export default "__VITE_ASSET__BzthTJIs__"